import React from "react";
import { PawPrint, ScanLine, Syringe, GraduationCap, Wind, Salad, CheckCircle2 } from "lucide-react";
import Reveal from "../Reveal";

const creds = [
  { icon: ScanLine, title: "Ultrasound Certified", text: "Additional certification in diagnostic ultrasound imaging." },
  { icon: Syringe, title: "Surgical Nursing", text: "Advanced qualification in surgical nursing and theatre care." },
  { icon: GraduationCap, title: "Nurse Educator", text: "Taught fellow nurses who are now qualified in the profession." },
  { icon: Wind, title: "Brachycephalic Anaesthesia", text: "7+ years working closely with brachycephalic breeds under anaesthesia." },
  { icon: Salad, title: "Nutritional Guidance", text: "Tailored advice for pets with allergies and sensitive stomachs." },
];

const NurseCredentials = () => {
  return (
    <section className="mx-auto max-w-[1290px] px-5 py-20 md:py-28">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <Reveal animation="fadeInLeft" className="relative">
          <img
            src="/pawelle/img_6.jpg"
            alt="Our experienced veterinary nurse caring for a pet"
            className="w-full rounded-[28px] object-cover shadow-[0_24px_60px_rgba(67,48,109,0.12)]"
          />
          <div className="absolute -bottom-6 -right-4 flex flex-col items-center justify-center rounded-[24px] bg-pawelle-primary px-8 py-6 text-center text-white shadow-[0_18px_40px_rgba(114,82,155,0.3)]">
            <span className="font-display text-[40px] font-bold leading-none">7+</span>
            <span className="mt-1 max-w-[7rem] font-body text-[13px] font-semibold leading-tight text-white/90">Years with Brachycephalic Anaesthesia</span>
          </div>
        </Reveal>

        <div>
          <Reveal animation="rubberBand">
            <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-pawelle-primary">
              <PawPrint className="h-5 w-5" /> Meet Your Nurse
            </span>
          </Reveal>
          <Reveal animation="fadeInUp" delay={100}>
            <h2 className="mt-4 max-w-xl font-display text-[30px] font-bold leading-tight text-pawelle-ink md:text-[38px]">
              A Qualified Veterinary Nurse You Can Truly Trust
            </h2>
          </Reveal>
          <Reveal animation="fadeInUp" delay={150}>
            <p className="mt-5 font-body text-[16px] leading-relaxed text-pawelle-body">
              I'm a veterinary nurse with a range of additional qualifications and certificates — including
              ultrasound and surgical nursing — and I've had the privilege of teaching other nurses who are now
              qualified in the profession. With over seven years working closely with brachycephalic breeds for
              anaesthesia, and specialist nutritional advice for pets with allergies and sensitive stomachs, your
              companion is in experienced, caring hands.
            </p>
          </Reveal>

          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            {creds.map((c, i) => {
              const Icon = c.icon;
              return (
                <Reveal key={c.title} animation="fadeInUp" delay={100 + i * 70} className="flex items-start gap-3 rounded-2xl bg-pawelle-bg p-4">
                  <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-white text-pawelle-primary">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h4 className="flex items-center gap-1.5 font-display text-[16px] font-semibold text-pawelle-ink">
                      {c.title}
                    </h4>
                    <p className="mt-1 font-body text-[13px] leading-relaxed text-pawelle-body">{c.text}</p>
                  </div>
                </Reveal>
              );
            })}
            <Reveal animation="fadeInUp" delay={100 + creds.length * 70} className="flex items-center gap-3 rounded-2xl bg-pawelle-primary p-4 text-white">
              <CheckCircle2 className="h-6 w-6 flex-shrink-0" />
              <p className="font-display text-[15px] font-semibold leading-tight">Compassionate, experienced care for every family pet.</p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NurseCredentials;
